import type { ButtonHTMLAttributes, FC, ReactNode } from "react";

interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  theme?: TButtonTheme;
}

type TButtonTheme = "primary" | "outline";

const themeClasses: Record<TButtonTheme, string> = {
  primary:
    "border border-transparent bg-[linear-gradient(63deg,#c90a6f,#e40057)] text-white hover:bg-[#e9004a] hover:bg-none",
  outline:
    "border-2 border-[#df0047] bg-transparent text-[#df0047] hover:bg-[#df0047] hover:text-white",
};

const Button: FC<IButton> = ({ children, theme = "primary", className = "", ...props }) => {
  return (
    <button
      {...props}
      className={`block w-full cursor-pointer rounded-md px-5 py-3.5 font-sans text-sm font-semibold uppercase tracking-wide shadow-md transition-all duration-250 hover:shadow-lg ${themeClasses[theme]} ${className}`.trim()}
    >
      {children}
    </button>
  );
};

export default Button;
